import Cookies from 'js-cookie';

const TokenKey = 'vue_vant_token';
const UserKey = 'vue_vant_userInfo'

export function getToken() {
  return Cookies.get(TokenKey);
}

export function getUserInfo() {
  var user = Cookies.get(UserKey)
  if (user) {
    return JSON.parse(user)
  }
  return user
}

export function setToken(token, userInfo) {
  Cookies.set(UserKey, userInfo)
  return Cookies.set(TokenKey, token);
}

export function removeToken() {
  Cookies.remove(UserKey)
  return Cookies.remove(TokenKey);
}
